import { render, staticRenderFns } from "./SubscriptionDialog.vue?vue&type=template&id=2b3e421e&scoped=true"
import script from "./SubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDialog.vue?vue&type=style&index=0&id=2b3e421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e421e",
  null
  
)

export default component.exports